import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "CardSchedule",
  components: {},
  props: ["w", "h"],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      list: [],
      rootUrl: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken"])),
  created: function created() {
    this.fetchList();
    this.rootUrl = "//" + this.$base.dataUrl.split("//")[1];
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchList: function fetchList() {
      var _this = this;

      this.loading = true;
      var obj = {};

      if (this.h == 1) {
        obj.pageSize = 4;
      } else if (this.h == 2) {
        obj.pageSize = 9;
      }

      obj.pageNum = 1;
      this.$http.post("/calendarSchedule/pageList", obj).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          data.resData.list.forEach(function (e, index) {
            _this.list.push({
              id: index,
              title: e.scheduleTitle,
              address: e.scheduleAddress,
              beginTime: e.beginTime,
              endTime: e.endTime,
              scheduleUrl: e.calendarScheduleUrl.replace("ip:port", _this.rootUrl) + "&sid=".concat(_this.userToken)
            });
          });
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    }
  },
  watch: {},
  filters: {}
};